<template>
    <div class="w-full flex flex-col items-center py-8">
        <div class="flex flex-col gap-8">
            <div v-for="index in circles" :key="index"
                class="w-48 h-48 rounded-full bg-blue-600 border-4 border-blue-800 shadow-lg"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const circles = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
</script>
